import { ErrorBoundary, VStack } from '@genial/components';
import React from 'react';

interface CustomerListEmptyProps {
  isLoading: boolean;
  hasFilter: boolean;
  hasData: boolean;
}

export const CustomerListEmpty: React.FC<CustomerListEmptyProps> = ({
  isLoading,
  hasFilter,
  hasData,
}) => {
  if (!isLoading && !hasData) {
    if (hasFilter) {
      return (
        <VStack py="stack.huge">
          <ErrorBoundary
            errorIconOrIllustration="NotFoundIllustration"
            errorTitle="Nenhum resultado corresponde à sua pesquisa"
            errorMessage="Por favor, verifique o campo informado e tente novamente."
          />
        </VStack>
      );
    }
    return (
      <VStack py="stack.huge">
        <ErrorBoundary
          errorIconOrIllustration="NotFoundIllustration"
          errorTitle="Você ainda não possui clientes."
          errorMessage="Você ainda não possui clientes para visualização de detalhes."
        />
      </VStack>
    );
  }

  return null;
};
